export default __webpack_public_path__ + "static/media/cube-white.52187fbc.svg";